import PanelForm from './../panel/Form'
import React from "react";

function Form() {

  return (
      <div className="wrapper" style={{padding: '0 10px 0 10px'}}>
          <PanelForm style={{background: '#FFFFFF', padding: 25}}>
              <h1>Über uns</h1>

              <h3>Warum es bildungs-urlaub.com gibt</h3>
              Jedes Jahr verschenken viele Arbeitnehmer ihren Anspruch auf Bildungsurlaub – nicht, weil sie keine Weiterbildung wollen, sondern weil der Weg dorthin kompliziert wirkt: Gesetzestexte, Anerkennungsbescheide, Fristen, Formulare.
              Genau da setzen wir an: Wir machen Bildungsurlaub so einfach, dass du ihn wirklich nutzt.

              <h3>Was wir für dich tun</h3>
              Auf bildungs-urlaub.com findest du Kurse, die sich für Bildungsurlaub eignen – von Sprachschulen bis Achtsamkeit – inklusive der Informationen, die dein Arbeitgeber für die Genehmigung braucht.
              Statt dich selbst durch PDFs und Paragraphen zu wühlen, bekommst du bei uns:
              <ul style={{paddingLeft: '20px'}}>
                  <li>Kurse, die passen: Wir listen nur Angebote, die für Bildungsurlaub geeignet sind oder bereits anerkannt wurden.</li>
                  <li>Antrag ohne Bastelei: Du trägst deine Daten ein – wir erzeugen ein sauberes PDF mit Kursinfo, Unterrichtseinheiten und Anerkennungsangaben.</li>
                  <li>Platz sichern: Wir reservieren deinen Wunschtermin direkt beim Anbieter.</li>
                  <li>Buchung ohne Stress: Sobald dein Arbeitgeber genehmigt, stoßen wir die verbindliche Buchung mit der Schule an.</li>
              </ul>

              <h3>So läuft es in der Praxis</h3>
              <ol style={{paddingLeft: '20px'}}>
                  <li>Kurs finden und Termin reservieren.</li>
                  <li>Antrag-PDF erstellen und beim Arbeitgeber einreichen.</li>
                  <li>Genehmigt? → In deinem Profil auf „Jetzt buchen“ klicken.</li>
                  <li>Die Rechnung kommt direkt vom Anbieter. Fertig.</li>
              </ol>

              <h3>Wie wir arbeiten</h3>
              Wir behalten für dich den Überblick über Anerkennungen, Unterrichtsumfang und Vorgaben je Bundesland.
              Unser Fokus:
              <ul style={{paddingLeft: '20px'}}>
                  <li>klare Informationen statt Fachchinesisch</li>
                  <li>vollständige Unterlagen, damit dein Arbeitgeber schnell entscheiden kann</li>
                  <li>möglichst wenig Hin-und-her mit Kursanbietern und Personalabteilung</li>
              </ul>

              <h3>Wer hinter der Seite steckt</h3>
              Wir sind ein kleines Team, das Sprachen, Reisen und Weiterbildung liebt – und selbst erlebt hat, wie unübersichtlich Bildungsurlaub auf den ersten Blick wirkt.
              Unser Job: gute Kurse finden, die Regeln je Bundesland im Blick behalten und dir einen klaren Prozess an die Hand geben, mit dem Bildungsurlaub machbar wird – auch neben einem vollen Arbeitsalltag.

              <h3>Dein nächster Schritt</h3>

              <ul style={{paddingLeft: '20px'}}>
                  <li>Kurse entdecken</li>
                  <li>Platz reservieren & Antrag-PDF erstellen</li>
                  <li>Fragen? Schreib uns: support@bildungs-urlaub.com</li>
              </ul>
          </PanelForm>
      </div>
  );
}

export default Form;
